var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.bodyColor)},[_c('MesaiRandevuDurum'),_c('InternetBaglantiDurumu'),_c('CookieMessage'),_c('InstallPrompt'),_c('VisitorHowManyTime'),_c('UpdatePrompt'),_c('PlatformMessage'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }